import classnames from "classnames";
import React from "react";

import { Props } from "../types";
import { getColor } from "../utils";
import { WarningTriangle } from "./WarningTriangle";
import styles from "./WarningTriangleInCircle.module.scss";

const WarningTriangleInCircle = (props: Props) => (
  <div className={classnames(styles.circle, getColor(styles, props.color!))}>
    <WarningTriangle {...props} />
  </div>
);

export { WarningTriangleInCircle };
